module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtLTk2IDI1NmEzMiAzMiAwIDAgMC0zMS44IDI4LjNMMzg0IDM1MnYzMjBhMzIgMzIgMCAwIDAgNjMuOCAzLjdMNDQ4IDY3MlYzNTJhMzIgMzIgMCAwIDAtMzItMzJ6IG0xOTIgMGEzMiAzMiAwIDAgMC0zMS44IDI4LjNMNTc2IDM1MnYzMjBhMzIgMzIgMCAwIDAgNjMuOCAzLjdMNjQwIDY3MlYzNTJhMzIgMzIgMCAwIDAtMzItMzJ6IiBmaWxsPSIjMCIgcC1pZD0iNDAwOCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Pause-filled.svg
// module id = /wC/
// module chunks = 73